import React from 'react';
import {AuthHighlightItem} from '../../pages/site/site.types';
import {Home} from 'lucide-react';
import SiteLink from './SiteLink';
import styles from './styles/AuthShowcasePanel.module.css';

interface AuthShowcasePanelProps {
    eyebrow?: string;
    title: string;
    description?: string;
    highlights: AuthHighlightItem[];
    footnote?: string;
    actionLabel: string;
    actionTo: string;
}

const AuthShowcasePanel: React.FC<AuthShowcasePanelProps> = ({
                                                                 eyebrow,
                                                                 title,
                                                                 description,
                                                                 highlights,
                                                                 footnote,
                                                                 actionLabel,
                                                                 actionTo
                                                             }) => {
    return (
        <aside className={styles.panel}>
            <div className={styles.brand}>
                <img alt="D-Sense" className={styles.logo} src="/d-sense.png"/>
                <div>
                    <strong>D-Sense</strong>
                </div>
            </div>
            {eyebrow && <span className="site-eyebrow">{eyebrow}</span>}
            <h1>{title}</h1>
            {description && <p>{description}</p>}
            <div className={styles.list}>
                {highlights.map(item => (
                    <article className={`site-card-soft ${styles.item}`} key={item.title}>
                        <strong>{item.title}</strong>
                        <span>{item.description}</span>
                    </article>
                ))}
            </div>
            <div className={styles.footer}>
                {footnote && <span>{footnote}</span>}
                <SiteLink className={styles.backLink} to={actionTo}><Home size={18}/></SiteLink>
            </div>
        </aside>
    );
};

export default AuthShowcasePanel;
